import { StyleSheet } from 'react-native';

export const styles = StyleSheet.create({
  container: {
    position: 'absolute',
    top: 0,
    left: 0,
    right: 0,
    bottom: 0,
    zIndex: 1000,
  },
  overlay: {
    flex: 1,
    backgroundColor: 'rgba(0, 0, 0, 0.5)',
    justifyContent: 'center',
    alignItems: 'center',
    paddingHorizontal: 20,
  },
  modal: {
    backgroundColor: '#FFFFFF',
    borderRadius: 16,
    width: '100%',
    maxHeight: '80%',
    shadowColor: '#000',
    shadowOffset: {
      width: 0,
      height: 4,
    },
    shadowOpacity: 0.25,
    shadowRadius: 8,
    elevation: 8,
  },
  header: {
    flexDirection: 'row',
    justifyContent: 'space-between',
    alignItems: 'center',
    paddingHorizontal: 20,
    paddingVertical: 16,
    borderBottomWidth: 1,
    borderBottomColor: '#F0F0F0',
  },
  title: {
    fontSize: 20,
    fontWeight: '700',
    color: '#2C3E50',
  },
  closeButton: {
    width: 32,
    height: 32,
    borderRadius: 16,
    backgroundColor: '#F8F9FA',
    justifyContent: 'center',
    alignItems: 'center',
  },
  closeButtonText: {
    fontSize: 24,
    color: '#95A5A6',
    fontWeight: '300',
  },
  content: {
    paddingHorizontal: 20,
    paddingVertical: 16,
  },
  scoreSection: {
    alignItems: 'center',
    paddingVertical: 20,
    borderBottomWidth: 1,
    borderBottomColor: '#F0F0F0',
    marginBottom: 20,
  },
  scoreContainer: {
    flexDirection: 'row',
    alignItems: 'center',
    marginBottom: 12,
  },
  scoreText: {
    marginLeft: 16,
    alignItems: 'center',
  },
  scoreValue: {
    fontSize: 32,
    fontWeight: '700',
    color: '#27AE60',
  },
  scoreLabel: {
    fontSize: 14,
    color: '#7F8C8D',
    fontWeight: '500',
  },
  scoreDescription: {
    fontSize: 14,
    color: '#7F8C8D',
    textAlign: 'center',
    lineHeight: 20,
    paddingHorizontal: 20,
  },
  section: {
    marginBottom: 24,
  },
  sectionTitle: {
    fontSize: 16,
    fontWeight: '600',
    color: '#2C3E50',
    marginBottom: 12,
  },
  timesContainer: {
    backgroundColor: '#F8F9FA',
    borderRadius: 8,
    padding: 12,
  },
  timesText: {
    fontSize: 16,
    fontWeight: '500',
    color: '#3498DB',
    textAlign: 'center',
  },
  noDataText: {
    fontSize: 14,
    color: '#95A5A6',
    fontStyle: 'italic',
    textAlign: 'center',
  },
  timingDetails: {
    marginTop: 12,
  },
  timingItem: {
    flexDirection: 'row',
    justifyContent: 'space-between',
    alignItems: 'center',
    paddingVertical: 8,
    paddingHorizontal: 12,
    backgroundColor: '#FFFFFF',
    borderRadius: 6,
    marginBottom: 4,
    borderWidth: 1,
    borderColor: '#E9ECEF',
  },
  timingTime: {
    fontSize: 14,
    fontWeight: '500',
    color: '#2C3E50',
  },
  timingRate: {
    alignItems: 'flex-end',
  },
  timingRateText: {
    fontSize: 14,
    fontWeight: '600',
  },
  timingRateLabel: {
    fontSize: 11,
    color: '#95A5A6',
  },
  quietHoursText: {
    fontSize: 16,
    fontWeight: '500',
    color: '#E74C3C',
    textAlign: 'center',
    backgroundColor: '#FDF2F2',
    paddingVertical: 12,
    paddingHorizontal: 16,
    borderRadius: 8,
  },
  patternsContainer: {
    flexDirection: 'row',
    flexWrap: 'wrap',
    gap: 8,
  },
  patternItem: {
    backgroundColor: '#E8F5E8',
    paddingHorizontal: 12,
    paddingVertical: 6,
    borderRadius: 16,
    alignItems: 'center',
  },
  patternType: {
    fontSize: 12,
    fontWeight: '600',
    color: '#27AE60',
  },
  patternCount: {
    fontSize: 10,
    color: '#7F8C8D',
  },
  channelsContainer: {
    gap: 8,
  },
  channelItem: {
    flexDirection: 'row',
    justifyContent: 'space-between',
    alignItems: 'center',
    paddingVertical: 12,
    paddingHorizontal: 16,
    backgroundColor: '#F8F9FA',
    borderRadius: 8,
  },
  channelName: {
    fontSize: 14,
    fontWeight: '500',
    color: '#2C3E50',
  },
  channelStatus: {
    paddingHorizontal: 8,
    paddingVertical: 4,
    borderRadius: 12,
  },
  channelEnabled: {
    backgroundColor: '#E8F5E8',
  },
  channelDisabled: {
    backgroundColor: '#FDF2F2',
  },
  channelStatusText: {
    fontSize: 12,
    fontWeight: '600',
  },
  channelEnabledText: {
    color: '#27AE60',
  },
  channelDisabledText: {
    color: '#E74C3C',
  },
  settingsContainer: {
    gap: 12,
  },
  settingItem: {
    flexDirection: 'row',
    justifyContent: 'space-between',
    alignItems: 'center',
    paddingVertical: 8,
  },
  settingLabel: {
    fontSize: 14,
    color: '#7F8C8D',
  },
  settingValue: {
    fontSize: 14,
    fontWeight: '500',
    color: '#2C3E50',
  },
  lastOptimizedText: {
    fontSize: 12,
    color: '#95A5A6',
    textAlign: 'center',
    fontStyle: 'italic',
  },
  footer: {
    paddingHorizontal: 20,
    paddingVertical: 16,
    borderTopWidth: 1,
    borderTopColor: '#F0F0F0',
  },
  preferencesButton: {
    backgroundColor: '#3498DB',
    paddingVertical: 12,
    paddingHorizontal: 24,
    borderRadius: 8,
    alignItems: 'center',
  },
  preferencesButtonText: {
    fontSize: 16,
    fontWeight: '600',
    color: '#FFFFFF',
  },
});
